export default __webpack_public_path__ + "static/media/Jeannie.acdb166c.png";